import gql from 'graphql-tag';

import integrationItemFragment from './integrationItemFragment';

export const similarIntegrationItemFragment = gql`
  fragment similarIntegrationItemFragment on SimilarIntegrationItem {
    dokkioClass
    integrationID
    remoteID
    integrationItem {
      ...integrationItemFragment
    }
    confidence
    similarIntegrationItemReasons
  }
  ${integrationItemFragment}
`;
export default similarIntegrationItemFragment;
